export function hasNativeModal(root) {
    return !!root && typeof root.showModal === "function" && typeof root.close === "function";
}

export function syncModalOpenClass() {
    document.documentElement.classList.toggle("modal-open", !!document.querySelector(".modal.is-active"));
}

export function setNativeModalOpen(root, open) {
    if (!root) {
        return;
    }

    root.classList.toggle("is-active", open);

    if (hasNativeModal(root)) {
        if (open && !root.open) {
            try {
                root.showModal();
            } catch (e) {
                // Keep the class-based modal fallback if native dialog state is rejected.
            }
        } else if (!open && root.open) {
            try {
                root.close();
            } catch (e) {
                // The class-based close path has already hidden the modal.
            }
        }
    }

    syncModalOpenClass();
}

export function bindNativeModalCancel(root, hideModal, isOpen) {
    if (!hasNativeModal(root)) {
        return;
    }

    root.addEventListener("cancel", function (event) {
        event.preventDefault();
        hideModal();
    });
    root.addEventListener("close", function () {
        const modalIsOpen = isOpen ? isOpen() : root.classList.contains("is-active");
        if (modalIsOpen) {
            hideModal();
        } else {
            syncModalOpenClass();
        }
    });
}
